module.exports = __webpack_public_path__ + "img/btch.7073b5e7.svg";